import translates from './in.json';
import restNotifications from './notifiers.json';

export default {
  in: { ...translates, ...restNotifications },
};
